import {app} from '../../app';
import IScope = angular.IScope;
import {SharedQuestionService} from "../../services/SharedQuestionService";
import {ISessionService} from "../../services/SessionService";
import {TextQuestionComponent} from "./TextQuestionComponent";
import {EmailSharedQuestion} from "../../sharedQuestions/EmailSharedQuestion";

export class EmailQuestionComponent extends TextQuestionComponent {

    setup() {
        this.sharedQuestion = new EmailSharedQuestion();

        super.setup();
    }

}

app.component('emailQuestion', {
    templateUrl: 'templates/components/questionTypes/emailQuestion.html',
    controller: EmailQuestionComponent,
    controllerAs: 'emailQuestion',
    bindings: {
        question: '<',
        nextQuestionCallback: '&',
        preventNextQuestion: '@'
    }
});